import clsx from "clsx";
import styled from "styled-components";
import React, { useState } from "react";
import translationIdle from "./images/Btn/Translate/translationIdle.png";
import translationHover from "./images/Btn/Translate/translationHover.png";
import translationActive from "./images/Btn/Translate/translationActive.png";
import translationActiveHover from "./images/Btn/Translate/translationActiveHover.png";
import { requestTranslation } from "@futures-platform/i18n";
const TranslationBtn = ({
  // color = '#b0b0b0',
  width = "39px",
  height = "39px",
  handler,
  isNewsBookMarked,
  widthOfView,
  newsData,
  isAuthed,
}) => {
  const [isHover, setIsHover] = useState(false);
  const isMobile = /Mobi/.test(window.navigator.userAgent)

  return (
    <FlagWrapper
      onMouseOver={() => {
        setIsHover(() => true);
      }}
      onMouseOut={() => {
        setIsHover(() => false);
      }}
      id="news-bookmark"
      onClick={handler}
      style={{
        // marginTop: widthOfView > 600 ? 0 : '8px',
        // marginTop: '4px',
        cursor: "pointer",
      }}
    >
      {!isAuthed ? (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-labelledby={requestTranslation("ShareSVG")}
          aria-describedby={requestTranslation("ShareSVG")}
        >
          <title>{requestTranslation("ShareSVG")}</title>
          <mask
            id="mask0_4080_888"
            style={{
              maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="36"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M36 18C36 27.9419 27.9409 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.9409 0 36 8.05815 36 18"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_4080_888)">
            <rect x="-6.10352e-05" width="36" height="36" fill="#E8EBEB" />
            <path
              d="M34.9999 18C34.9999 27.3888 27.3888 35 17.9999 35C8.6111 35 0.999939 27.3888 0.999939 18C0.999939 8.61116 8.6111 1 17.9999 1C27.3888 1 34.9999 8.61116 34.9999 18Z"
              fill="white"
            />
            <circle
              cx="21.7647"
              cy="23.647"
              r="1.85294"
              fill="#637282"
              stroke="#637282"
            />
            <circle
              cx="21.7647"
              cy="12.3529"
              r="1.85294"
              fill="#637282"
              stroke="#637282"
            />
            <circle
              cx="12.3529"
              cy="18"
              r="1.85294"
              fill="#637282"
              stroke="#637282"
            />
            <line
              x1="23.5292"
              y1="11.5458"
              x2="12.235"
              y2="18.134"
              stroke="#637282"
              stroke-width="1.4"
            />
            <line
              x1="12.235"
              y1="17.8659"
              x2="23.5292"
              y2="24.4542"
              stroke="#637282"
              stroke-width="1.4"
            />
          </g>
        </svg>
      ) : (
        <>
          {!!isNewsBookMarked && (
            <>
              {!isHover || !!isMobile ? (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-labelledby={requestTranslation("ShareSVG")}
          aria-describedby={requestTranslation("ShareSVG")}
                >
                  <title>{requestTranslation("ShareSVG")}</title>
                  <mask
                    id="mask0_4080_916"
                    style={{
                      maskType: "luminance",
                    }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="36"
                    height="36"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M36 18C36 27.9419 27.9409 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.9409 0 36 8.05815 36 18"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_4080_916)">
                    <rect
                      x="-6.10352e-05"
                      width="36"
                      height="36"
                      fill="#00C3FF"
                    />
                    <path
                      d="M34.9999 18C34.9999 27.3888 27.3888 35 17.9999 35C8.6111 35 0.999939 27.3888 0.999939 18C0.999939 8.61116 8.6111 1 17.9999 1C27.3888 1 34.9999 8.61116 34.9999 18Z"
                      fill="white"
                    />
                    <circle
                      cx="21.7647"
                      cy="23.647"
                      r="1.85294"
                      fill="#00C3FF"
                      stroke="#00C3FF"
                    />
                    <circle
                      cx="21.7647"
                      cy="12.3529"
                      r="1.85294"
                      fill="#00C3FF"
                      stroke="#00C3FF"
                    />
                    <circle
                      cx="12.3529"
                      cy="18"
                      r="1.85294"
                      fill="#00C3FF"
                      stroke="#00C3FF"
                    />
                    <line
                      x1="23.5292"
                      y1="11.5458"
                      x2="12.235"
                      y2="18.134"
                      stroke="#00C3FF"
                      strokeWidth="1.4"
                    />
                    <line
                      x1="12.235"
                      y1="17.8659"
                      x2="23.5292"
                      y2="24.4542"
                      stroke="#00C3FF"
                      strokeWidth="1.4"
                    />
                  </g>
                </svg>
              ) : (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-labelledby={requestTranslation("ShareSVG")}
          aria-describedby={requestTranslation("ShareSVG")}
                >
                  <title>{requestTranslation("ShareSVG")}</title>
                  <mask
                    id="mask0_4080_902"
                    style={{
                      maskType: "luminance",
                    }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="36"
                    height="36"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M36 18C36 27.9419 27.9409 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.9409 0 36 8.05815 36 18"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_4080_902)">
                    <rect
                      x="-6.10352e-05"
                      width="36"
                      height="36"
                      fill="#689AB9"
                    />
                    <path
                      d="M34.9999 18C34.9999 27.3888 27.3888 35 17.9999 35C8.6111 35 0.999939 27.3888 0.999939 18C0.999939 8.61116 8.6111 1 17.9999 1C27.3888 1 34.9999 8.61116 34.9999 18Z"
                      fill="white"
                    />
                    <circle
                      cx="21.7647"
                      cy="23.647"
                      r="1.85294"
                      fill="#689AB9"
                      stroke="#689AB9"
                    />
                    <circle
                      cx="21.7647"
                      cy="12.3529"
                      r="1.85294"
                      fill="#689AB9"
                      stroke="#689AB9"
                    />
                    <circle
                      cx="12.3529"
                      cy="18"
                      r="1.85294"
                      fill="#689AB9"
                      stroke="#689AB9"
                    />
                    <line
                      x1="23.5292"
                      y1="11.5458"
                      x2="12.235"
                      y2="18.134"
                      stroke="#689AB9"
                      strokeWidth="1.4"
                    />
                    <line
                      x1="12.235"
                      y1="17.8659"
                      x2="23.5292"
                      y2="24.4542"
                      stroke="#689AB9"
                      strokeWidth="1.4"
                    />
                  </g>
                </svg>
              )}
            </>
          )}
          {!isNewsBookMarked && (
            <>
              {!isHover || !!isMobile ? (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-labelledby={requestTranslation("ShareSVG")}
          aria-describedby={requestTranslation("ShareSVG")}
                >
                  <title>{requestTranslation("ShareSVG")}</title>
                  <mask
                    id="mask0_4080_888"
                    style={{
                      maskType: "luminance",
                    }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="36"
                    height="36"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M36 18C36 27.9419 27.9409 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.9409 0 36 8.05815 36 18"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_4080_888)">
                    <rect
                      x="-6.10352e-05"
                      width="36"
                      height="36"
                      fill="#E8EBEB"
                    />
                    <path
                      d="M34.9999 18C34.9999 27.3888 27.3888 35 17.9999 35C8.6111 35 0.999939 27.3888 0.999939 18C0.999939 8.61116 8.6111 1 17.9999 1C27.3888 1 34.9999 8.61116 34.9999 18Z"
                      fill="white"
                    />
                    <circle
                      cx="21.7647"
                      cy="23.647"
                      r="1.85294"
                      fill="#637282"
                      stroke="#637282"
                    />
                    <circle
                      cx="21.7647"
                      cy="12.3529"
                      r="1.85294"
                      fill="#637282"
                      stroke="#637282"
                    />
                    <circle
                      cx="12.3529"
                      cy="18"
                      r="1.85294"
                      fill="#637282"
                      stroke="#637282"
                    />
                    <line
                      x1="23.5292"
                      y1="11.5458"
                      x2="12.235"
                      y2="18.134"
                      stroke="#637282"
                      strokeWidth="1.4"
                    />
                    <line
                      x1="12.235"
                      y1="17.8659"
                      x2="23.5292"
                      y2="24.4542"
                      stroke="#637282"
                      strokeWidth="1.4"
                    />
                  </g>
                </svg>
              ) : (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-labelledby={requestTranslation("ShareSVG")}
          aria-describedby={requestTranslation("ShareSVG")}
                >
                  <title>{requestTranslation("ShareSVG")}</title>
                  <mask
                    id="mask0_4080_902"
                    style={{
                      maskType: "luminance",
                    }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="36"
                    height="36"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M36 18C36 27.9419 27.9409 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.9409 0 36 8.05815 36 18"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_4080_902)">
                    <rect
                      x="-6.10352e-05"
                      width="36"
                      height="36"
                      fill="#689AB9"
                    />
                    <path
                      d="M34.9999 18C34.9999 27.3888 27.3888 35 17.9999 35C8.6111 35 0.999939 27.3888 0.999939 18C0.999939 8.61116 8.6111 1 17.9999 1C27.3888 1 34.9999 8.61116 34.9999 18Z"
                      fill="white"
                    />
                    <circle
                      cx="21.7647"
                      cy="23.647"
                      r="1.85294"
                      fill="#689AB9"
                      stroke="#689AB9"
                    />
                    <circle
                      cx="21.7647"
                      cy="12.3529"
                      r="1.85294"
                      fill="#689AB9"
                      stroke="#689AB9"
                    />
                    <circle
                      cx="12.3529"
                      cy="18"
                      r="1.85294"
                      fill="#689AB9"
                      stroke="#689AB9"
                    />
                    <line
                      x1="23.5292"
                      y1="11.5458"
                      x2="12.235"
                      y2="18.134"
                      stroke="#689AB9"
                      strokeWidth="1.4"
                    />
                    <line
                      x1="12.235"
                      y1="17.8659"
                      x2="23.5292"
                      y2="24.4542"
                      stroke="#689AB9"
                      strokeWidth="1.4"
                    />
                  </g>
                </svg>
              )}
            </>
          )}
        </>
      )}
    </FlagWrapper>
  );
};

export default TranslationBtn;

const FlagWrapper = styled.div`
  background: transparent;
  // border-radius: 100%;
  // box-shadow: 0px 2px 3px 0px rgb(0 0 0 / 10%);
  // width: 36px;
  // height: 36px;
  // & svg:last-child {
  //   display: none;
  //   width: 0;
  //   height: 0;
  // }
  // &:hover svg:last-child {
  //   display: block;
  //   width: 36px;
  //   height: 36px;
  // }
  // &:hover svg:first-child {
  //   display: none;
  // }
`;

export const EditButton = styled.img`
  cursor: pointer;
  background-color: transparent;
  color: transparent;
  width: 150px;
  height: 30px;
`;
